import { arrayMove } from "@dnd-kit/sortable";
import React from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";

export const FROZEN_COLUMN_INDEXES = [0, 1, 2, 3];

export default function useColumnOrder(initial) {
  const [order, setOrder] = useState(initial);
  useEffect(() => setOrder(initial), [initial]);

  const move = useCallback(
    (activeId, overId) => {
      if (!overId || activeId === overId) return;
      const a = order.indexOf(activeId);
      const b = order.indexOf(overId);
      if (
        FROZEN_COLUMN_INDEXES.includes(a) ||
        FROZEN_COLUMN_INDEXES.includes(b)
      )
        return;
      setOrder((prev) => arrayMove(prev, a, b));
    },
    [order]
  );

  const handleDragEnd = useCallback(
    (event) => {
      const { active, over } = event;
      if (!active?.id || !over?.id) return;
      move(String(active.id), String(over.id));
    },
    [move]
  );

  return [order, handleDragEnd];
}
